/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
  // Table,
} from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"

import { useDispatch, useSelector } from "react-redux"
// import { useDispatch } from "react-redux"
import dayjs from "dayjs"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
// import { AppDispatch } from "../.."
import AlertComponent from "../../../components/AlertComponent"
// import ConfirmModal from "../../components/ConfirmModal"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import TextInput from "../../../components/InputWrapper/TextInput"
// import CheckInput from "../../../components/InputWrapper/CheckInput"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import {
  clearAlert,
  setAlerts,
  // setWarningAlerts,
} from "../../../globalStore/alertStore"
// import {
//   画面ロック解除,
//   画面ロック開始,
// } from "../../../globalStore/progressStore"
import ZyomuinKyuyoMasterService from "../../../service/driverpayroll/zyomuinKyuyoMaster/zyomuinKyuyoMasterService"
import {
  TZyomuinKyuyoMasterListGetReq,
  // TZyomuinKyuyoMasterListGetRes,
  TZyomuinKyuyoMasterListItem,
} from "../../../service/driverpayroll/zyomuinKyuyoMaster/TZyomuinKyuyoMaster"

import { 給与管理メニューコード } from "../../../constant/menuCode"

import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import { RootState } from "../../../globalStore/rootreducer"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import BusyoService from "../../../service/master/busyo/busyoService"
import dateUtil from "../../../ts/util/dateUtil"

// //#region [type]

// DefaultCombo
export type TItem = { name: string; value: any }

export type T乗務員給与マスタ明細リスト = TZyomuinKyuyoMasterListItem & {
  行ID: symbol
}

// #endregion

// defaultComboBox用
const boolList: TItem[] = [
  {
    name: "在籍",
    value: "0",
  },
  {
    name: "退職",
    value: "1",
  },
]

/**
 * 乗務員給与マスタ一覧
 * @returns
 */
const ZyomuinKyuyoMasterList = () => {
  const history = useHistory()
  const location = useLocation()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "ZyomuinKyuyoMasterList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TZyomuinKyuyoMasterListItem>,
    pageSize: number
  ) =>
    new wjCore.CollectionView(data, {
      pageSize,

      calculatedFields: {
        年齢: (i: T乗務員給与マスタ明細リスト) => {
          if (i.生年月日 == null || wjCore.isNullOrWhiteSpace(i.生年月日))
            return undefined
          const today = dayjs(eigyobi)
          return today.diff(i.生年月日, "year")
        },
        在籍年数: (i: T乗務員給与マスタ明細リスト) => {
          return dateUtil.to在籍年月数Str(eigyobi, i.入社年月日, i.退職年月日)
        },
      },

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TZyomuinKyuyoMasterListGetReq) => {
    setSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TZyomuinKyuyoMasterListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new ZyomuinKyuyoMasterService().getList(
        currentSearchCondition
      )

      // 検索結果をstateにセット
      setGridData({
        data: createCollectionView(
          res.data.map((v) => {
            return {
              ...v,
              行ID: Symbol(),
            }
          }),
          pageSize
        ),
      })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TZyomuinKyuyoMasterListGetReq = queryString.parse(
      location.search
    )
    set部所コード(query.部所コード ?? "")
    set社員コード(query.社員コード ?? "")
    set社員氏名(query.社員氏名 ?? "")
    set退職フラグ(query.退職フラグ != null ? query.退職フラグ.toString() : null)

    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TZyomuinKyuyoMasterListGetReq => {
    return {
      部所コード: 部所コード ?? "",
      社員コード: 社員コード ?? "",
      社員氏名: 社員氏名 ?? "",
      退職フラグ:
        退職フラグ != null && !wjCore.isNullOrWhiteSpace(退職フラグ)
          ? parseInt(退職フラグ)
          : undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TZyomuinKyuyoMasterListGetReq
  ) => {
    return {
      部所: 部所ItemSource?.find(
        (i) => i.部所コード === searchCondition.部所コード
      )?.部所名,
      社員コード: searchCondition.社員コード,
      社員氏名: searchCondition.社員氏名,
      退職: boolList?.find(
        (i) => i.value === searchCondition.退職フラグ?.toString()
      )?.name,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!searching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)
    // 検索項目をクリア
    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // アコーディオンを開く
    setAccordionController(true)
  }

  const clearSearchState = () => {
    set部所コード("")
    set社員コード("")
    set社員氏名("")
    set退職フラグ("")
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    // ヘッダーに行追加
    // header行に一行追加
    var extraRow = new wjGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    // ヘッダー行に文言追加
    columnHeaders.columns.forEach((c, index) => {
      c.allowMerging = true
      c.align = "right"
      if (c.binding?.includes("社員")) {
        columnHeaders.setCellData(0, index, "社員")
        c.align = "left"
      } else if (c.binding?.includes("部所名")) {
        columnHeaders.setCellData(0, index, "所属部所")
        c.align = "left"
      } else {
        columnHeaders.setCellData(0, index, c.header)
      }
    })
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const rowData: T乗務員給与マスタ明細リスト = e.getRow().dataItem
      if (!rowData) return
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [searching, setSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  // ComboBox制御
  const [comboDataInitialized, setComboDataInitialized] =
    useState<boolean>(false)

  //#endregion

  //#region [state]

  // ComboBoxState
  const [退職フラグComboBox, set退職フラグComboBox] = useState<TWijmoComboBox<
    number,
    TItem
  > | null>(null)
  const [退職フラグIsLoadEnded, set退職フラグIsLoadEnded] =
    useState<boolean>(false)
  const [退職フラグItemSource, set退職フラグItemSource] = useState<TItem[]>()

  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  // 設定
  const [部所コード, set部所コード] = useState<string | null>(null)
  const [社員コード, set社員コード] = useState<string>()
  const [社員氏名, set社員氏名] = useState<string>()
  const [退職フラグ, set退職フラグ] = useState<string | null>(null)

  //#endregion

  //#region [effect]

  useEffect(() => {
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set退職フラグItemSource(boolList)
      set部所ItemSource(部所ListRes.data)
    })
  }, [])

  useEffect(() => {
    if (!部所IsLoadEnded || !退職フラグIsLoadEnded) return

    setComboDataInitialized(true)
  }, [部所IsLoadEnded, 退職フラグIsLoadEnded])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && comboDataInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition)
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
      }
    }
  }, [gridInitialized, comboDataInitialized])

  useEffect(() => {
    document.title = `乗務員給与マスタ一覧`
  }, [])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">乗務員給与マスタ一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card>
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <ComboBox.Busyo
                              autoFocus={true}
                              placeholder="部所"
                              isAllSelect={true}
                              itemsSource={部所ItemSource}
                              selectedValue={部所コード}
                              setSelectedValue={set部所コード}
                              listFilter={(d) => d.運行部所フラグ === 1}
                              isLoadEnded={部所IsLoadEnded}
                              setIsLoadEnded={set部所IsLoadEnded}
                              ComboBox={部所ComboBox}
                              setComboBox={set部所ComboBox}></ComboBox.Busyo>
                            <div className="input-group">
                              <TextInput
                                style={{ width: "8rem" }}
                                id="社員コード"
                                name="社員コード"
                                value={社員コード}
                                setValue={set社員コード}
                                maxLength={4}
                                placeholder="社員コード"
                              />
                              <TextInput
                                id="社員氏名"
                                name="社員氏名"
                                value={社員氏名}
                                setValue={set社員氏名}
                                maxLength={100}
                                placeholder="社員氏名"
                              />
                            </div>
                            <ComboBox.Default
                              className="max-w-10rem"
                              placeholder="退職"
                              isAllSelect={true}
                              itemsSource={退職フラグItemSource}
                              selectedValue={退職フラグ}
                              setSelectedValue={set退職フラグ}
                              isLoadEnded={退職フラグIsLoadEnded}
                              setIsLoadEnded={set退職フラグIsLoadEnded}
                              ComboBox={退職フラグComboBox}
                              setComboBox={
                                set退職フラグComboBox
                              }></ComboBox.Default>
                          </div>
                          <div className="search-condition-row">
                            <Button
                              type="submit"
                              disabled={searching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                search()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={searching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}>
                <wjrGrid.FlexGridColumn
                  header=" "
                  allowMerging="true"
                  align="center"
                  width={70}
                  selectable={false}
                  isReadOnly>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TZyomuinKyuyoMasterListItem>
                    ) => {
                      // 社員登録
                      const url = util.getMenuPath(
                        給与管理メニューコード.乗務員給与マスタ登録
                      )[0]

                      return (
                        <Button
                          className="btn btn-small btn-primary move-edit-page"
                          onClick={() => {
                            // 画面全体のスクロール位置の保存
                            gridPageHelper.savePageConditionData(
                              location.pathname
                            )

                            // TODO:乗務員IDと給与IDを渡して使う？
                            history.push(
                              url.replaceAll(
                                ":id",
                                context.item.乗務員ID.toString()
                              )
                            )
                          }}>
                          編集
                        </Button>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="部所名"
                  width={140}
                  header="所属部所"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員コード"
                  width={100}
                  header="社員番号"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員氏名"
                  width={128}
                  header="氏名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="年齢"
                  width={80}
                  header="年齢"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="在籍年数"
                  width={110}
                  header="在籍年数"></wjrGrid.FlexGridColumn>

                <wjrGrid.FlexGridColumn
                  binding="基本給"
                  format="G"
                  width={100}
                  header="基本給"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="時間外単価"
                  format="G"
                  width={120}
                  header="時間外単価"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="深夜残単価"
                  format="G"
                  width={120}
                  header="深夜残単価"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="日曜残単価"
                  format="G"
                  width={120}
                  header="日曜残単価"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="休日手当"
                  format="G"
                  width={100}
                  header="休日手当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="通勤費_非課税"
                  format="G"
                  width={100}
                  header="通勤費"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="通勤費_課税"
                  format="G"
                  width={120}
                  header="通勤費税込"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="評価割増"
                  format="G"
                  width={100}
                  header="評価割増"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="住宅手当"
                  format="G"
                  width={100}
                  header="住宅手当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="能力開発"
                  format="G"
                  width={100}
                  header="能力開発"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="業務手当"
                  format="G"
                  width={100}
                  header="業務手当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="その他手当"
                  format="G"
                  width={100}
                  header="その他手当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="退職年月日"
                  width={100}
                  header="退職日">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TZyomuinKyuyoMasterListItem>
                    ) => {
                      let dDate = ""
                      if (context.item.退職年月日)
                        dDate = dayjs(context.item.退職年月日).format(
                          "YYYY/MM/DD"
                        )

                      return (
                        <>
                          <span>{dDate}</span>
                        </>
                      )
                    }}></wjrGrid.FlexGridCellTemplate>
                </wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default ZyomuinKyuyoMasterList

//#region  ダミーデータ

//#endregion
